<template>
  <div class="key-code-page">
    <div class="key-code-content">
      <div class="page-head">
        <h1>{{ pageTitle }}</h1>
        <p>{{ pageTips }}</p>
      </div>

      <div class="step-bar" :class="`step-current-${currentStep}`">
        <div class="step-line">
          <span class="line-progress"></span>
          <span
            class="line-dot"
            v-if="currentStep < 2"
          ></span>
          <span
            class="line-dot line-dot-right"
            :class="{ active: currentStep === 2 }"
            v-if="currentStep < 3"
          ></span>
        </div>
        <div
          class="step-item"
          v-for="item in steps"
          :key="item.value"
          :class="{ active: currentStep >= item.value }"
        >
          <i>{{ item.value }}</i>
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div class="form-state" v-if="pageStatus === 'input'">
        <div class="section-title">填写信息</div>
        <input
          v-model.trim="handCode"
          class="hand-input"
          type="text"
          maxlength="20"
          placeholder="请输入手牌号"
        />
      </div>

      <div class="qr-state" v-if="pageStatus === 'qrcode'">
        <div class="qr-box">
          <vue-qr :text="qrCodeText" :size="420" :margin="0"></vue-qr>
        </div>
        <p class="qr-desc">请顾客使用微信扫描授权二维码并绑定手牌</p>
        <p class="expire-tips">{{ countDown }}秒后授权二维码将失效</p>
      </div>

      <div class="success-state" v-if="pageStatus === 'success'">
        <div class="success-icon">
          <i></i>
        </div>
        <p class="success-subtitle">恭喜您</p>
        <p class="success-title">{{ handCode }}已绑定成功</p>
      </div>
    </div>

    <button
      v-if="pageStatus !== 'success'"
      class="bottom-btn"
      :class="{ disabled: loading }"
      :disabled="loading"
      @click="handleBottomClick"
    >
      {{ bottomText }}
    </button>
  </div>
</template>

<script>
import { getScanCardBinderInfo, getScanTakeNumberInfo } from "@/api/scan";

export default {
  name: "KeyCodeQRCreate",
  data() {
    return {
      pageStatus: "input",
      handCode: "",
      qrCodeText: "",
      countDown: 60,
      loading: false,
      timer: null,
      pollTimer: null,
      steps: [
        { value: 1, label: "生成授权" },
        { value: 2, label: "顾客识别" },
        { value: 3, label: "授权成功" },
      ],
    };
  },
  computed: {
    currentStep() {
      const stepMap = {
        input: 1,
        qrcode: 2,
        success: 3,
      };
      return stepMap[this.pageStatus];
    },
    pageTitle() {
      if (this.pageStatus === "qrcode") {
        return `手牌号：${this.handCode}`;
      }
      if (this.pageStatus === "success") {
        return "授权结果";
      }
      return "授权绑定手牌";
    },
    pageTips() {
      if (this.pageStatus === "qrcode") {
        return "请向顾客出示二维码，60秒内完成绑定！";
      }
      if (this.pageStatus === "success") {
        return "恭喜你，已帮助顾客完成手牌绑定！";
      }
      return "输入顾客手牌号，点击“生成授权二维码”！";
    },
    bottomText() {
      return this.pageStatus === "qrcode"
        ? "重新生成授权二维码"
        : "生成授权二维码";
    },
    canSubmit() {
      return Boolean(this.handCode);
    },
  },
  created() {
    const query = this.$route.query || {};
    if (query.handCode || query.keyCode || query.tableCode) {
      this.handCode = query.handCode || query.keyCode || query.tableCode;
    }
    if (query.status === "success" || query.bindStatus === "success") {
      this.pageStatus = "success";
    }
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    handleBottomClick() {
      if (this.pageStatus === "qrcode") {
        this.createQrCode();
        return;
      }
      if (!this.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
      this.createQrCode();
    },
    createQrCode() {
      if (!this.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
      this.loading = true;
      this.clearTimers();
      getScanTakeNumberInfo({
        TableCode: this.handCode,
        tableCode: this.handCode,
        KeyCode: this.handCode,
      })
        .then((res) => {
          this.qrCodeText = this.getQrCodeText(res);
          this.pageStatus = "qrcode";
          this.countDown = 60;
          this.startCountDown();
          this.startBindPolling();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getQrCodeText(res) {
      if (typeof res === "string") {
        return res;
      }
      const qrFields = [
        "QCode",
        "QrCode",
        "QRCode",
        "QrCodeText",
        "QrCodeParaText",
        "Url",
        "url",
        "WechatPointUrl",
        "wechatpointurl",
      ];
      const qrText = qrFields.map((key) => res && res[key]).find(Boolean);
      if (qrText) {
        return qrText;
      }
      return JSON.stringify({
        action: "keyCodeBind",
        tableCode: this.handCode,
        time: Date.now(),
      });
    },
    startCountDown() {
      this.timer = setInterval(() => {
        if (this.countDown <= 1) {
          this.clearTimers();
          this.countDown = 0;
          return;
        }
        this.countDown -= 1;
      }, 1000);
    },
    startBindPolling() {
      const vpnCode =
        (this.$store.state.vpnInfo && this.$store.state.vpnInfo.code) ||
        this.$store.state.vpnNumber ||
        "";
      if (!vpnCode) {
        return;
      }
      this.pollTimer = setInterval(() => {
        getScanTakeNumberInfo({ vpnCode })
          .then((res) => {
            if (typeof res === "string" || !res.TableCode) {
              return;
            }
            this.handCode = res.TableCode || this.handCode;
            this.showSuccess();
          })
          .catch(() => {});
      }, 3000);
    },
    showSuccess() {
      this.pageStatus = "success";
      this.clearTimers();
    },
    clearTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.key-code-page {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
  padding-bottom: 94px;
  color: #333;
}

.key-code-content {
  box-sizing: border-box;
  padding: 34px 30px 0;
}

.page-head {
  h1 {
    margin: 0;
    line-height: 44px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
  }

  p {
    margin-top: 30px;
    line-height: 32px;
    font-size: 22px;
    color: #a6a6a6;
  }
}

.step-bar {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 58px 42px 0;
}

.step-line {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 20px;
  height: 5px;
  background: #edf4fb;
  border-radius: 5px;
  overflow: visible;

  .line-progress {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 5px;
    background: var(--tc);
    border-radius: 5px;
  }

  .line-dot {
    position: absolute;
    top: 0;
    width: 10px;
    height: 5px;
    border-radius: 4px;
    background: var(--tc);
    box-shadow: 20px 0 0 var(--tc), 40px 0 0 var(--tc);
  }

  .line-dot {
    left: 24%;
  }

  .line-dot-right {
    left: 72%;
  }
}

.step-current-1 .line-progress {
  width: 24%;
}

.step-current-2 .line-progress {
  width: 72%;
}

.step-current-3 .line-progress {
  width: 100%;
}

.step-item {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 112px;
  color: #d6deed;
  font-size: 20px;
  font-weight: 500;

  i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #edf4fb;
    color: #d6deed;
    font-size: 22px;
    font-style: normal;
  }

  span {
    margin-top: 16px;
    line-height: 28px;
  }

  &.active {
    color: var(--tc);

    i {
      background: var(--tc);
      color: #fff;
    }
  }
}

.form-state {
  margin-top: 78px;
}

.section-title {
  position: relative;
  display: inline-block;
  line-height: 34px;
  font-size: 24px;
  font-weight: 500;
  color: #333;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 116px;
    height: 10px;
    background: var(--tc);
    opacity: 0.28;
  }
}

.hand-input {
  display: block;
  width: 100%;
  height: 82px;
  margin-top: 44px;
  padding: 0 40px;
  border: 0;
  border-radius: 42px;
  outline: none;
  box-sizing: border-box;
  background: #f8f8f8;
  color: #333;
  font-size: 22px;

  &::placeholder {
    color: #888;
  }
}

.qr-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 96px;
}

.qr-box {
  width: 420px;
  height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-desc {
  margin-top: 42px;
  line-height: 28px;
  font-size: 20px;
  color: #999;
}

.expire-tips {
  margin-top: 22px;
  line-height: 30px;
  font-size: 20px;
  font-weight: 500;
  color: #ff4d4f;
}

.success-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 82px;
}

.success-icon {
  position: relative;
  width: 330px;
  height: 330px;
  border-radius: 50%;
  background: rgba(0, 205, 196, 0.12);

  &::before {
    content: "";
    position: absolute;
    inset: 44px;
    border-radius: 50%;
    background: rgba(0, 205, 196, 0.2);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 88px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--tc), rgba(130, 239, 202, 0.72));
  }

  i {
    position: absolute;
    z-index: 1;
    left: 112px;
    top: 140px;
    width: 132px;
    height: 60px;
    border-left: 16px solid #fff;
    border-bottom: 16px solid #fff;
    border-radius: 6px;
    transform: rotate(-45deg);
  }
}

.success-subtitle {
  margin-top: 62px;
  line-height: 34px;
  font-size: 24px;
  color: #999;
}

.success-title {
  margin-top: 42px;
  line-height: 48px;
  font-size: 38px;
  font-weight: 600;
  color: var(--tc);
}

.bottom-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 94px;
  border: 0;
  outline: none;
  background: var(--tc);
  color: #fff;
  font-size: 26px;
  font-weight: 400;

  &.disabled {
    opacity: 0.45;
  }
}
</style>
